module.exports = __webpack_public_path__ + "media/images/png-download-ee0cadd9a195e80e2ef95d3394081393.svg";